export default __webpack_public_path__ + "static/media/jet-mobile_converted.76126c21.jpg";